/* eslint-disable jsdoc/check-indentation */
import {CustomSearchSourceConfiguration} from "../core/config/search-configuration";

/**
 * Custom search class to search for measurement stations
 */
export class SearchStation {

    placeholder: "Suche Station";
    lyr: __esri.FeatureLayer;
    searchFields: string[];
    outFields: string[];
    maxSuggestions: number;
    maxResults: number;
    orderByFields: string[];

    constructor(props?: CustomSearchSourceConfiguration) {
        if (props) {
            props.maxSuggestions = props.hasOwnProperty("maxSuggestions") ? props.maxSuggestions : 6;
            props.maxResults = props.hasOwnProperty("maxResults") ? props.maxResults : 6;
            Object.assign(this, props);
        }
    }

    /**
     * Provide a getSuggestions method
     * to provide suggestions to the Search widget
     */
    getSuggestions(params: any): Promise<__esri.SuggestResult[]> {
        // query layer attributes
        // TODO: query for each field in searchField
        const promises: any[] = [];
        this.searchFields.forEach((field) => {
            const promise = this.lyr.queryFeatures({
                where: `${field} = '${params.suggestTerm}'`,
                returnGeometry: false,
                outFields: this.outFields,
                num: params.maxSuggestions,
                orderByFields: this.orderByFields
            }).then((results: any) => {
                // Return Suggestion results to display
                // in the Search widget
                return results.features.map((feature: any) => {
                    return {
                        key: field,
                        text: feature.properties.label,
                        sourceIndex: params.sourceIndex
                    };
                });
            });
            promises.push(promise);
        });

        return Promise.all(promises);
    }

    /**
     * Provide a getResults method to find
     * results from the suggestions
     *
     * @param params
     */
    getResults(params: any): Promise<__esri.SearchResult[]> {
        /**
         * If the Search widget passes the current location,
         * you can use this in your own custom source
         * const operation = params.location ? "reverse/" : "search/";
         * const query = {};
         * // You can perform a different query if a location
         * // is provided
         * if (params.location) {
         *     query.lat = params.location.latitude;
         *     query.lon = params.location.longitude;
         * } else {
         *     query.q = params.suggestResult.text.replace(/ /g, "+");
         *     query.limit = 6;
         * }
         */
        // eslint-disable-next-line no-console
        console.log(params);
        return this.lyr.queryFeatures({
            // where: `${field} = '${params.suggestTerm}'`,
            returnGeometry: true,
            outFields: this.outFields,
            num: params.maxResults,
            orderByFields: this.orderByFields
        }).then( (results: any) => {
            // Parse the results of your custom search
            // Return an array of Search Results
            return results.features.map((feature: any) => {
                // Optionally, you can provide an extent for
                // a point result, so the view can zoom to it
                const buffer = __esri.geometryEngine.geodesicBuffer(feature.geometry, 100, "meters");
                // Return a Search Result
                return {
                    extent: buffer[0].extent,
                    feature,
                    name: feature.properties.label
                };
            });
        });
    }
}
